export default class HomeController {
  constructor($location, $stateParams, APIConfig, appModel, appServices, SessionProvider, utils) {
    "ngInject";
    this.$location = $location;
    this.$stateParams = $stateParams;
    this.APIConfig = APIConfig;
    this.appModel = appModel;
    this.appServices = appServices;
    this.SessionProvider = SessionProvider;
    this.utils = utils;
  }

  $onInit() {
    const username = this.$stateParams.username;
    const password = this.$stateParams.password;
    const uoid = this.$stateParams.uoid;

    const urlParameters = this.$location.search();

    this.appModel.setCredentials(username, password, uoid);
    this.appModel.setDebugMode(urlParameters.debug === 'on');
  }
}



// WEBPACK FOOTER //
// ./client/app/pages/home/home.controller.js